/* hs-eslint ignored failing-rules */

// @ts-expect-error ts-migrate(2305) FIXME: Module '"flux-actions"' has no exported member 'cr... Remove this comment to see the full error message
import { createAction } from 'flux-actions';
import keyMirror from 'react-utils/keyMirror';
import { mapPayloadTo } from './utils';
import * as SecurityPhoneNumberAPI from '../api/SecurityPhoneNumberAPI';
import * as TwoFactorAuthAPI from '../api/TwoFactorAuthAPI';
import { fromJSON as phoneValidationConfigureResponse } from '../records/PhoneValidationConfigureResponse';
import { twoFactorAuthNudgeInitiated } from 'settings-ui-security/lib/tracker';
import { CONFIRMED } from '../constants/TwoFactorAuthDeviceStatuses';
import { trackTwoFactorSetup, TwoFactorAuthTypes, TwoFactorEventActions } from '../lib/tracker';
export const TwoFactorAuthActionTypes = keyMirror({
  CANCELLED_2FA_SETUP: null,
  CHANGED_SMS_REGISTRATION_NUMBER: null,
  CHANGED_VERIFICATION_CODE_ATTEMPT: null,
  CLICKED_SETUP_2FA_BACKUP: null,
  CLICKED_SETUP_2FA: null,
  CLOSED_SETUP_2FA_BACKUP: null,
  COMPLETED_2FA_SETUP: null,
  COMPLETED_BACKUP_CODES: null,
  COMPLETED_GA_REGISTRATION: null,
  COMPLETED_GA_VERIFICATION: null,
  COMPLETED_HUBSPOT_APP_REGISTRATION: null,
  COMPLETED_SMS_VERIFICATION: null,
  CONFIRM_VERIFICATION_CODE_ATTEMPT: null,
  CONFIRMED_2FA_METHOD_FAILURE: null,
  CONFIRMED_2FA_METHOD_REQUEST: null,
  CONFIRMED_2FA_METHOD_SUCCESS: null,
  CONFIRMED_2FA_METHOD: null,
  CONFIRMED_SMS_NUMBER: null,
  CONFIRMED_VALIDATION_FAILURE: null,
  CONFIRMED_VALIDATION_REQUEST: null,
  CONFIRMED_VALIDATION_SUCCESS: null,
  CONFIRMED_VERIFICATION_CODE_FAILURE: null,
  CONFIRMED_VERIFICATION_CODE_REQUEST: null,
  CONFIRMED_VERIFICATION_CODE_SUCCESS: null,
  FETCHED_2FA_STATUS_FAILURE: null,
  FETCHED_2FA_STATUS_REQUEST: null,
  FETCHED_2FA_STATUS_SUCCESS: null,
  FETCHED_BACKUP_CODES_REQUEST: null,
  FETCHED_BACKUP_CODES_SUCCESS: null,
  FETCHED_HUBSPOT_APP_VERSION_FAILURE: null,
  FETCHED_HUBSPOT_APP_VERSION_REQUEST: null,
  FETCHED_HUBSPOT_APP_VERSION_SUCCESS: null,
  FETCHED_SETUP_PORTAL_2FA_STATUS_FAILURE: null,
  FETCHED_SETUP_PORTAL_2FA_STATUS_REQUEST: null,
  FETCHED_SETUP_PORTAL_2FA_STATUS_SUCCESS: null,
  GENERATED_2FA_BACKUP_FAILURE: null,
  GENERATED_2FA_BACKUP_REQUEST: null,
  GENERATED_2FA_BACKUP_SUCCESS: null,
  HUBSPOT_APP_STATUS_FAILURE: null,
  HUBSPOT_APP_STATUS_REQUEST: null,
  HUBSPOT_APP_STATUS_SUCCESS: null,
  PRINTED_OR_SAVED_BACKUP_CODES: null,
  REDIRECT_TO_LOGIN: null,
  REDIRECT_TO_SECONDARY_2FA_SETUP: null,
  REQUESTED_2FA_GENERATE_BACKUP: null,
  REQUESTED_2FA_STATUS: null,
  SELECT_2FA_SETUP_NUDGE: null,
  SELECTED_2FA_METHOD: null,
  SETUP_2FA_FROM_NUDGE: null,
  SKIP_2FA_SETUP_NUDGE: null,
  STARTED_SETUP_2FA_FOR_LOGIN: null,
  TURNED_OFF_2FA_FAILURE: null,
  TURNED_OFF_2FA_REQUEST: null,
  TURNED_OFF_2FA_SUCCESS: null,
  TURNED_OFF_2FA: null,
  USER_LOGIN_REQUIRED_FOR_2FA: null
});
export const requestTwoFactorAuthGenerateBackupCodes = createAction(TwoFactorAuthActionTypes.REQUESTED_2FA_GENERATE_BACKUP);
export const generateTwoFactorAuthBackupCodesRequest = createAction(TwoFactorAuthActionTypes.GENERATED_2FA_BACKUP_REQUEST);
export const generateTwoFactorAuthBackupCodesSuccess = createAction(TwoFactorAuthActionTypes.GENERATED_2FA_BACKUP_SUCCESS, payload => payload);
export const generateTwoFactorAuthBackupCodesFailure = createAction(TwoFactorAuthActionTypes.GENERATED_2FA_BACKUP_FAILURE, mapPayloadTo('error'));
export const setup2faBackup = createAction(TwoFactorAuthActionTypes.CLICKED_SETUP_2FA_BACKUP);
export const close2faBackup = createAction(TwoFactorAuthActionTypes.CLOSED_SETUP_2FA_BACKUP);
export const skip2FASetupNudge = createAction(TwoFactorAuthActionTypes.SKIP_2FA_SETUP_NUDGE);
export const select2FASetupNudge = createAction(TwoFactorAuthActionTypes.SELECT_2FA_SETUP_NUDGE, mapPayloadTo('precedence'));
export const setup2fa = createAction(TwoFactorAuthActionTypes.CLICKED_SETUP_2FA, mapPayloadTo('precedence', 'stagedMethod'));
export const setup2faForLogin = createAction(TwoFactorAuthActionTypes.STARTED_SETUP_2FA_FOR_LOGIN, mapPayloadTo('portalId', 'redirectUrl'));
export const selectMethod = createAction(TwoFactorAuthActionTypes.SELECTED_2FA_METHOD, mapPayloadTo('method'));
export const confirmMethod = createAction(TwoFactorAuthActionTypes.CONFIRMED_2FA_METHOD, mapPayloadTo('precedence', 'method'));
export const confirmMethodRequest = createAction(TwoFactorAuthActionTypes.CONFIRMED_2FA_METHOD_REQUEST);
export const confirmMethodSuccess = createAction(TwoFactorAuthActionTypes.CONFIRMED_2FA_METHOD_SUCCESS, mapPayloadTo('response'));
export const confirmMethodFailure = createAction(TwoFactorAuthActionTypes.CONFIRMED_2FA_METHOD_FAILURE, mapPayloadTo('error', 'context'));
export const confirmValidationRequest = createAction(TwoFactorAuthActionTypes.CONFIRMED_VALIDATION_REQUEST);
export const confirmValidationSuccess = createAction(TwoFactorAuthActionTypes.CONFIRMED_VALIDATION_SUCCESS, mapPayloadTo('response', 'phonenumber'));
export const confirmValidationFailure = createAction(TwoFactorAuthActionTypes.CONFIRMED_VALIDATION_FAILURE, mapPayloadTo('error', 'phonenumber'));
export const completeGoogleAuthRegistration = createAction(TwoFactorAuthActionTypes.COMPLETED_GA_REGISTRATION);
export const completeHubSpotApp = createAction(TwoFactorAuthActionTypes.COMPLETED_HUBSPOT_APP_REGISTRATION);
export const changeVerificationCodeAttempt = createAction(TwoFactorAuthActionTypes.CHANGED_VERIFICATION_CODE_ATTEMPT, mapPayloadTo('precedence', 'codeAttempt'));
export const confirmVerificationCodeAttempt = createAction(TwoFactorAuthActionTypes.CONFIRM_VERIFICATION_CODE_ATTEMPT, mapPayloadTo('precedence', 'codeAttempt', 'twoFactorConfig'));
export const confirmVerificationCodeRequest = createAction(TwoFactorAuthActionTypes.CONFIRMED_VERIFICATION_CODE_REQUEST);
export const confirmVerificationCodeSuccess = createAction(TwoFactorAuthActionTypes.CONFIRMED_VERIFICATION_CODE_SUCCESS, mapPayloadTo('config'));
export const confirmVerificationCodeFailure = createAction(TwoFactorAuthActionTypes.CONFIRMED_VERIFICATION_CODE_FAILURE, mapPayloadTo('error'));
export const completeGoogleAuthVerification = createAction(TwoFactorAuthActionTypes.COMPLETED_GA_VERIFICATION);
export const completeSetup = createAction(TwoFactorAuthActionTypes.COMPLETED_2FA_SETUP);
export const cancelSetup = createAction(TwoFactorAuthActionTypes.CANCELLED_2FA_SETUP);
export const confirmSMSNumber = createAction(TwoFactorAuthActionTypes.CONFIRMED_SMS_NUMBER, mapPayloadTo('precedence', 'number'));
export const completeSMSVerification = createAction(TwoFactorAuthActionTypes.COMPLETED_SMS_VERIFICATION);
export const printedOrSavedBackupCodes = createAction(TwoFactorAuthActionTypes.PRINTED_OR_SAVED_BACKUP_CODES);
export const completeBackupCodes = createAction(TwoFactorAuthActionTypes.COMPLETED_BACKUP_CODES);
export const requestTwoFactorAuthStatus = createAction(TwoFactorAuthActionTypes.REQUESTED_2FA_STATUS);
export const fetchTwoFactorAuthStatusRequest = createAction(TwoFactorAuthActionTypes.FETCHED_2FA_STATUS_REQUEST);
export const fetchTwoFactorAuthStatusSuccess = createAction(TwoFactorAuthActionTypes.FETCHED_2FA_STATUS_SUCCESS, mapPayloadTo('status'));
export const fetchTwoFactorAuthStatusFailure = createAction(TwoFactorAuthActionTypes.FETCHED_2FA_STATUS_FAILURE, mapPayloadTo('error'));
export const turnOffTwoFactorAuth = createAction(TwoFactorAuthActionTypes.TURNED_OFF_2FA, mapPayloadTo('precedence', 'secondaryEnabled'));
export const turnOffTwoFactorAuthRequest = createAction(TwoFactorAuthActionTypes.TURNED_OFF_2FA_REQUEST);
export const turnOffTwoFactorAuthSuccess = createAction(TwoFactorAuthActionTypes.TURNED_OFF_2FA_SUCCESS, mapPayloadTo('status'));
export const turnOffTwoFactorAuthFailure = createAction(TwoFactorAuthActionTypes.TURNED_OFF_2FA_FAILURE, mapPayloadTo('error', 'precedence', 'secondaryEnabled'));
export const fetchSetupPortalTwoFactorStatusRequest = createAction(TwoFactorAuthActionTypes.FETCHED_SETUP_PORTAL_2FA_STATUS_REQUEST);
export const fetchSetupPortalTwoFactorStatusSuccess = createAction(TwoFactorAuthActionTypes.FETCHED_SETUP_PORTAL_2FA_STATUS_SUCCESS, mapPayloadTo('status'));
export const fetchSetupPortalTwoFactorStatusFailure = createAction(TwoFactorAuthActionTypes.FETCHED_SETUP_PORTAL_2FA_STATUS_FAILURE, mapPayloadTo('error', 'portalId'));
export const requireUserLogin = createAction(TwoFactorAuthActionTypes.USER_LOGIN_REQUIRED_FOR_2FA);
export const redirectToLogin = createAction(TwoFactorAuthActionTypes.REDIRECT_TO_LOGIN);
export const redirectToSecondary2faSetup = createAction(TwoFactorAuthActionTypes.REDIRECT_TO_SECONDARY_2FA_SETUP, mapPayloadTo('stagedMethod'));
export const fetchBackupCodesRequest = createAction(TwoFactorAuthActionTypes.FETCHED_BACKUP_CODES_REQUEST);
export const fetchBackupCodesSuccess = createAction(TwoFactorAuthActionTypes.FETCHED_BACKUP_CODES_SUCCESS, payload => payload);
export const fetchBackupCodes = () => dispatch => {
  dispatch(fetchBackupCodesRequest());
  TwoFactorAuthAPI.fetchBackupCodes().then(res => {
    if (res && res.backupCodes.length === 0) {
      dispatch(requestTwoFactorAuthGenerateBackupCodes());
    }
    dispatch(fetchBackupCodesSuccess(res));
    dispatch(setup2faBackup());
  }).catch(error => {
    if (error && error.status === 400) {
      dispatch(requestTwoFactorAuthGenerateBackupCodes());
      dispatch(setup2faBackup());
    }
  });
};
export function changeSMSNumber(number) {
  return dispatch => {
    dispatch({
      type: TwoFactorAuthActionTypes.CONFIRMED_VALIDATION_REQUEST
    });
    SecurityPhoneNumberAPI.validatePhoneNumber(number).then(response => {
      dispatch({
        type: TwoFactorAuthActionTypes.CONFIRMED_VALIDATION_SUCCESS,
        payload: {
          response: phoneValidationConfigureResponse(response),
          phoneNumber: number
        }
      });
    }).catch(err => {
      dispatch({
        type: TwoFactorAuthActionTypes.CONFIRMED_VALIDATION_FAILURE,
        payload: {
          error: err,
          phoneNumber: number
        }
      });
    });
  };
}
export const setup2faFromNudge = redirectUrl => {
  return dispatch => {
    dispatch({
      type: TwoFactorAuthActionTypes.SETUP_2FA_FROM_NUDGE,
      payload: {
        redirectUrl
      }
    });
    twoFactorAuthNudgeInitiated();
  };
};
export const fetchHubSpotAppStatus = precedence => {
  return dispatch => {
    dispatch({
      type: TwoFactorAuthActionTypes.HUBSPOT_APP_STATUS_REQUEST
    });
    TwoFactorAuthAPI.fetchHubSpotAppSetup(precedence).then(response => {
      if (response === CONFIRMED) {
        trackTwoFactorSetup(TwoFactorAuthTypes.HUBSPOT_AUTHENTICATOR, TwoFactorEventActions.ACCOMPLISHED);
      }
      dispatch({
        type: TwoFactorAuthActionTypes.HUBSPOT_APP_STATUS_SUCCESS,
        payload: response
      });
    }).catch(() => {
      dispatch({
        type: TwoFactorAuthActionTypes.HUBSPOT_APP_STATUS_FAILURE
      });
    });
  };
};
export const fetchHubSpotAppVersion = precedence => {
  return dispatch => {
    dispatch({
      type: TwoFactorAuthActionTypes.FETCHED_HUBSPOT_APP_VERSION_REQUEST
    });
    TwoFactorAuthAPI.checkHSAppVersion(precedence).then(response => {
      dispatch({
        type: TwoFactorAuthActionTypes.FETCHED_HUBSPOT_APP_VERSION_SUCCESS,
        payload: response
      });
    }).catch(error => {
      if (error.responseJSON && error.responseJSON.status === 'APP_OUTDATED') {
        dispatch({
          type: TwoFactorAuthActionTypes.FETCHED_HUBSPOT_APP_VERSION_FAILURE
        });
      }
    });
  };
};